import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  deliverySuccessMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  editInfoUserService,
  changePasswordAuthService,
  uploadUserService,
} from "../../../services/userServices";
import { setUserAction } from "./../../../redux/actions/userActions/userActions";
import { validateFile } from "../../../utils";
import { uploadTypeItems } from "../../../utils/enum";

export const profileUserContext = createContext({
  isShowEditModal: null,
  setIsShowEditModal: () => {},
  isShowPasswordModal: null,
  setIsShowPasswordModal: () => {},
  handleEditUserInfo: () => {},
  handleChangePassword: () => {},
  handleUploadFile: () => {},
});

const ProfileUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const [isShowEditModal, setIsShowEditModal] = useState(false);
  const [isShowPasswordModal, setIsShowPasswordModal] = useState(false);

  // Edit User Info
  const handleEditUserInfo = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editInfoUserService(userData);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        setIsShowEditModal(false);
        dispatch(setUserAction());
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Change Password
  const handleChangePassword = async (userData) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await changePasswordAuthService(userData);
      if (status === 200) {
        deliverySuccessMessage(data.resultMessage, "/auth/logout", "3000");
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Upload File
  const handleUploadFile = async (file, callback) => {
    const fileErrorMessage = validateFile(file);
    if (fileErrorMessage) return toastErrorMessage(fileErrorMessage);

    const objData = { file };
    const params = { destination: uploadTypeItems[1] };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await uploadUserService(objData, params);
      if (status === 200) {
        callback && callback(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <profileUserContext.Provider
        value={{
          isShowEditModal,
          setIsShowEditModal,
          isShowPasswordModal,
          setIsShowPasswordModal,
          handleEditUserInfo,
          handleChangePassword,
          handleUploadFile,
        }}
      >
        {children}
      </profileUserContext.Provider>
    </>
  );
};

export default ProfileUserContext;
